var _excluded = ["children"];
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';
import { jsx as _jsx } from "react/jsx-runtime";
var ListViewAction = function ListViewAction(props) {
  var children = props.children,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  if (children) {
    return /*#__PURE__*/_jsx(Button, Object.assign({
      className: "action",
      fluid: true
    }, rest, {
      children: children
    }));
  }
  return /*#__PURE__*/_jsx(Button, Object.assign({
    className: "action",
    fluid: true
  }, rest));
};
ListViewAction.handledProps = ["children"];
ListViewAction.propTypes = {
  children: PropTypes.node
};
ListViewAction.defaultProps = {
  children: null
};
export default ListViewAction;